import { QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const leaderRatingsKeys = new QueryKeyFactoryGenerator('leader-ratings').getDefault();
